var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38327 0 0 5.38327 0 12C0 18.6167 5.38327 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38327 18.6167 0 12 0ZM18.6515 9.55511L10.9876 17.219C10.7543 17.4523 10.431 17.5862 10.1013 17.5862V18.1051L10.0901 17.5862C9.75594 17.5833 9.43135 17.4437 9.1994 17.2032L5.33293 13.1956C4.85293 12.6982 4.8672 11.9035 5.36458 11.4235C5.59939 11.1967 5.90841 11.0722 6.23455 11.0722C6.57782 11.0722 6.89825 11.2081 7.13669 11.4551L10.1174 14.5445L16.8794 7.78275C17.116 7.54612 17.4307 7.41561 17.7657 7.41561C18.1004 7.41561 18.4151 7.54586 18.6518 7.78249C19.1401 8.27131 19.1401 9.06655 18.6515 9.55511Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkIcon);
export default __webpack_public_path__ + "static/media/green-checkmark-icon.36463963.svg";
export { ForwardRef as ReactComponent };